import { string, shape } from 'prop-types';
import { propTypes as linkPropTypes } from '../../../01_atoms/Link';

export const PTItemWithLogo = {
  name: string.isRequired,
  nextLink: shape(linkPropTypes),
  logoURL: string,
};

export const PTItemWithLogoDefaults = {
  linkPropTypes: null,
  logoURL: null,
};
